<template>
  <div id="app">
    <!--   顶部栏 -->
    <!--    <div id="nav">-->
    <!--      <router-link to="/">Home</router-link> |-->
    <!--      <router-link to="/about">About</router-link>-->
    <!--    </div>-->

    <!-- 手机端  v-if="ISphone"  v-else -->
    <div v-if="ISphone" class="fx-column fx-row-center">
      <div
        class="phonenavhead fx-row fx-row-center fx-row-space-between"
        style="box-shadow:0px 4px 8px 0px rgba(0,0,0,0.1);"
      >
        <img src="./assets/Logo.png" style="margin-left:4vw; width:20vw; " class="logoicon" />

        <!-- phonelinebutton  icon_nav_icon_more_ph -->
        <img
          class="phonebutton"
          style="margin-right:4vw;width:7vw;"
          @click="phonebtnclick"
          src="./assets/icon_nav_icon_more_ph.png"
        />

        <!-- <div class="phonebutton" @click="phonebtnclick">手机端按钮</div> -->
      </div>

      <div class="phonemenuview">
        <el-collapse-transition>
          <div v-show="ISshowtab">
            <!-- fx-row fx-row-center  fx-wrap -->
            <div class="transition_box">
              <!-- fx-row fx-row-center fx-row-space-around fx-wrap -->
              <div class="menubgview fx-column fx-row-center" style="width;100vw;">
                <!-- 6个选项 -->

                <!-- phoneFoldView  -->
                <div class="menucell" @click="handleSelect(1)">首页</div>
                <div class="menucell" @click="foldsecclick1()">App推广</div>
                <div class="phoneFoldView">
                  <el-collapse-transition>
                    <div class="fx-column fx-row-center" v-show="ISshowfoldsec1">
                      <div class="menufoldcell" @click="handleSelect(7)">用户获取</div>
                      <div class="menufoldcell" @click="handleSelect(8)">信息流推广</div>
                      <!-- <div class="menufoldcell" @click="handleSelect(9)">ASO推广</div> -->
                    </div>
                  </el-collapse-transition>
                </div>

                <div class="menucell" @click="handleSelect(3)">小程序</div>
                <div class="menucell" @click="foldsecclick2()">广告服务</div>

                <div class="phoneFoldView">
                  <el-collapse-transition>
                    <div class="fx-column fx-row-center" v-show="ISshowfoldsec2">
                      <div class="menufoldcell" @click="handleSelect(10)">媒体广告运营</div>
                      <div class="menufoldcell" @click="handleSelect(11)">全球出海营销</div>
                      <div class="menufoldcell" @click="handleSelect(12)">电商推广</div>
                      <!-- <div class="menufoldcell" @click="handleSelect(13)">短视频推广</div> -->
                    </div>
                  </el-collapse-transition>
                </div>
                <div class="menucell" @click="handleSelect(6)">短视频推广</div>
                <div class="menucell" @click="handleSelect(14)" v-show="isShowWjxh">无极星河</div>
              </div>
            </div>
          </div>
        </el-collapse-transition>
      </div>
    </div>

    <!-- PC端 -->
    <div class="pcnavhead" v-else style="box-shadow:0px 4px 8px 0px rgba(0,0,0,0.1);">
      <el-row>
        <el-col :span="5">
          <div class="head_section fx-column fx-row-center fx-row-middle">
            <!--          Grow Rotate  hvr_wobble_top  -->
            <img src="./assets/Logo.png" class="logoicon hvr_grow_rotate" />
          </div>
        </el-col>

        <el-col :span="14">
          <!--        选项卡-->
          <div class="head_section">
            <!-- getnowindex  activeIndex -->
            <el-menu
              :default-active="getnowindex"
              class="navbarbgview"
              text-color="#444D6D"
              mode="horizontal"
              @select="handleSelect"
              background-color="#FFFFFF"
              active-text-color="#65C8F4"
            >
              <!-- <div class="sectiojnone"></div> -->
              <el-menu-item index="1">
                <div class="sectiojnone">首页</div>
              </el-menu-item>
              
              <!-- sectiojnone sectionarray   -->
              <!-- <div class="sectionarray">App推广</div> -->

              <el-submenu index="2">
                <template slot="title">App推广</template>

                <el-menu-item style="height:60px; line-height: 60px; " index="7">
                  <div class="height_60">用户获取</div>
                </el-menu-item>
                <el-menu-item style="height:60px; line-height: 60px;" index="8">
                  <div class="height_60">信息流推广</div>
                </el-menu-item>
                <!-- <el-menu-item style="height:60px; line-height: 60px;" index="9">
                  <div class="height_60">ASO推广</div>
                </el-menu-item> -->
              </el-submenu>
              <el-menu-item index="3">
                <div class="sectiojnone">小程序</div>
              </el-menu-item>
             

              <!-- <el-menu-item index="5">
              <div class="sectiojnone">广告服务</div></el-menu-item
              >-->
              <el-submenu index="4">
                <template slot="title">广告服务</template>

                <el-menu-item style="height:60px; line-height: 60px;" index="10">
                  <div class="sectiojnone">媒体广告运营</div>
                </el-menu-item>
                <el-menu-item style="height:60px; line-height: 60px;" index="11">
                  <div class="sectiojnone">全球出海营销</div>
                </el-menu-item>
                <el-menu-item style="height:60px; line-height: 60px;" index="12">
                  <div class="sectiojnone">电商推广</div>
                </el-menu-item>
                <!-- <el-menu-item index="13">
                  <div class="sectiojnone">短视频推广</div>
                </el-menu-item>-->
              </el-submenu>

              <el-menu-item index="5">
                <!-- 联系我们 短视频推广   -->
                <div class="sectiojnone">短视频推广</div>
              </el-menu-item>
               <el-menu-item index="14" v-show="isShowWjxh">
                <div class="sectiojnone">无极星河</div>
              </el-menu-item>
            </el-menu>

            <!--   以上新写法  -->
          </div>
        </el-col>

        <el-col :span="5">
          <!--        投放按钮-->
          <div class="head_section fx-column fx-row-bottom fx-row-middle">
            <!--          hvr_grow_shadow hvr_grow -->
            <div class="navredbutton" v-if="IShowred" @click="jumptocontanctus">投放广告</div>

            <div
              v-else
              class="pushbutton hvr_grow_shadow"
              style="margin-right:60px; font-size: 0.828vw;"
              @click="jumptocontanctus"
            >投放广告</div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div v-if="ISphone" style="width:100%;height:15vw;background:white;"></div>

    <div v-if="!ISphone" style="width:100%;height:60px;background:white;"></div>

    <router-view />
    <div class="footer">
      广州幂动科技有限公司版权所有©2017
      <span>
        <img src="./assets/nationalEmblem.png" />
        <a class="link" href="https://beian.miit.gov.cn/#/Integrated/index">
          粤ICP备17137942号 {{beiAnGetUrl()}}
        </a>
      </span>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "",
  components: {},
  computed: {
    getnowindex() {
      return this.$store.state.activeIndex;
    }
  },
  data() {
    return {
      IShowred: false, //是否滚动的标志

      ISphone: false,
      ISshowtab: false,
      ISshowfoldsec1: false,
      ISshowfoldsec2: false,
      isShowWjxh:false,

      tablelist: [
        "首页",
        "App推广",
        "小程序",
        "广告服务",
        "投放广告"
      ],
      activeNames: ["1"]
    };
  },

  /**
   * Click events
   */
  methods: {
    /**
     * @method 获取备案号
     * @return {string} 备案号后缀
     */
    beiAnGetUrl () {
      const href = window.location.href
      if (href.includes('4hnovel.cn')) { return '-28' }
      if (href.includes('aaxinwen.net')) { return '-12' }
      if (href.includes('4lnovel.cn')) { return '-32' }
      if (href.includes('bbxinwen.net')) { return '-15' }
      if (href.includes('4jnovel.cn')) { return '-30' }
      if (href.includes('4gnovel.cn')) { return '-27' }
      if (href.includes('ddxinwen.net')) { return '-16' }
      return ''
    },

    menucellclick(value) {
      console.log("点击的value==" + value);
    },

    handleChange(val) {
      console.log("点击了val==" + val);
    },
    //  , keyPath , keyPath
    handleSelect(key) {
      console.log("点击了key==" + key);
      //共用一个跳转
      this.ISshowtab = false;
      // Home  Extension  WeChat   Headlines   Adserve ContactUs

      // 2区域    Extension
      // getuer    Extension
      // InformationPromotion      信息流推广
      // ASOPromotion  ASO推广

      // 5区域  Adserve
      // MediaAdvertisingOperation  Adserve
      // GlobalMarketing   全球出海营销
      // Marketpromotion  电商推广
      // ShortVideoPromotion  短视频推广
      // 7 8 9  10 11 12 13

      let keystr = key + "";

      //切换 indexvalue

      this.$store.commit("updateactiveIndex", keystr);

      // ContactUs
      let urlarray = [
        "Home",
        "Home",
        "Extension",
        "WeChat",
        "Headlines",
        "Adserve",
        "ShortVideoPromotion",
        "Extension",
        "InformationPromotion",
        "ASOPromotion",
        "newmediapromotion",
        "GlobalMarketing",
        "Adserve",
        "ShortVideoPromotion",
        'Wjxh'
      ];
      console.log('11111111:',key);
      

      let target = urlarray[key];
      this.$router.push({
        path: target
      });
    },

    //点击了移动按钮
    phonebtnclick() {
      console.log("点击了手机端按钮~");
      this.ISshowtab = !this.ISshowtab;
    },

    foldsecclick1() {
      this.ISshowfoldsec1 = !this.ISshowfoldsec1;
    },

    foldsecclick2() {
      this.ISshowfoldsec2 = !this.ISshowfoldsec2;
    },

    jumptocontanctus() {
      //  跳入联系我们
      //改变激活角标index
      this.$store.commit("updateactiveIndex", "0");

      // console.log("点击了联系我们按钮后~" + this.$store.state.activeIndex);
      //push jump
      this.$router.push({
        path: "/ContactUs"
      });
    },

    handleScroll() {
      let that = this;
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      console.log(scrollTop);
      if (scrollTop > 210) {
        console.log("可以开始变红");

        if (that.IShowred) {
          return;
        }
        that.IShowred = true;
      } else {
        console.log("其他情况");

        if (!that.IShowred) {
          return;
        }
        that.IShowred = false;
      }
    }
  },

  /**
   * Life cycle function
   */
  mounted() {
    //可用于设置自适应屏幕，根据获得的可视宽度（兼容性）判断是否显示
    let w = document.documentElement.offsetWidth || document.body.offsetWidth;
    if (w < 1000) {
      this.$appdata.ISphone = true;
      this.ISphone = this.$appdata.ISphone;
    }
    window.addEventListener("scroll", this.handleScroll);

    console.log(
      "this.$store.state.activeIndex==" + this.$store.state.activeIndex
    );

    if (window.location.hostname == 'ai.midongtech.com') {
      this.isShowWjxh = true
    }
    
  }
};
</script>

<style lang="less">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.head_section {
  width: 100%;
  height: 61px;
  background: #ffffff;
}

.logoicon {
  width: 40%;
  // height: 40px;
  /*background-color: red;*/
}

.pushbutton {
  background-color: #16224a;

  color: white;
  // line-height: 40px;
  // border-radius: 20px;

  width: 6vw;
  height: 2vw;
  line-height: 2vw;
  border-radius: 1vw;
  cursor: pointer;
}

.navbarbgview {
  width: 50vw;
}

.sectionarray {
  width: 6.3vw;
  text-align: center;
  height: auto;
  font-weight: bold;
}

.transition_box {
  // margin-bottom: 10px;
  width: 100vw;
  height: 20vw;
  // border-radius: 4px;
  // background-color: #409eff;
  // text-align: center;
  // color: #fff;
  // padding: 40px 20px;
  // box-sizing: border-box;
  // margin-right: 20px;
}

.tabcell {
  width: 33vw;
  height: 9vw;
  margin-top: 1vw;
  // background: red;
}

.onbutton {
  width: 25vw;
}

.head_section .el-menu-item {
  width: 8.3vw !important;
  padding: 0 0;
  margin: 0 0;
  text-align: center;
  font-weight: bold;
}

.el-submenu {
  width: 8.3vw !important;
  padding: 0 0;
  margin: 0 0;
  text-align: center;
  font-weight: bold;
}

// 设置下面的样式就可以了
// .el-menu {
//   border-right-width: 0;
// }

.pcnavhead {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9999 !important;
}

.phonenavhead {
  height: 15vw;
  width: 100vw;
  background: white;

  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9999 !important;

  // background: #0eadf2;
}
// phonemenuview
.phonemenuview {
  // margin-top: 15vw;

  background: white;

  position: fixed;
  left: 0;
  top: 15vw;
  right: 0;
  z-index: 8999 !important;
}

.menubgview {
  height: 100vh;
  background: white;
}

.el-collapse {
  // width: 90%;
  border: none !important;

  width: 90%;
  font-size: 5vw;
  text-align: left;
  height: 10vw;
  background: white;
  // border-bottom: 1px solid lightgray;
  // margin: 2vw 0;
}

.el-collapse-item {
  font-size: 5vw;
  text-align: left;
}

// .el-collapse-item
// {
//     width: 90%;
//   font-size: 5vw;
//   text-align: left;
//   height: 10vw;
//   background: white;
//   border-bottom: 1px solid lightgray;
//   margin: 2vw 0;
// }

.menucell {
  width: 90%;
  font-size: 4vw;
  text-align: left;
  height: 10vw;
  background: white;
  border-bottom: 1px solid lightgray;
  margin: 2vw 0;
}

.menufoldcell {
  width: 80%;
  font-size: 4vw;
  text-align: left;
  height: 10vw;
  background: white;
  border-bottom: 1px solid lightgray;
  margin: 2vw 0;
}

// <!-- phoneFoldView  -->

.phoneFoldView {
  width: 100%;
}

.navredbutton {
  background: #ff496a;
  color: white;
  width: 50%;
  height: 100%;
  line-height: 60px;
  font-size: 0.828vw;
  cursor: pointer;

  // width: 5vw;
  // height: 3vw;
  // line-height: 3vw;
}

.height_60 {
  // height: 60px;

  // line-height: 60px;
  // font-weight: middle;
}

.footer {
  display: flex;
  align-items: center;
  background-color: #3b4146;
  text-align: center;
  justify-content: center;
  color: #fff;
  padding: 20px;
  font-size: 14px;

  span {
    display: flex;
    align-items: center;
    img {
      margin-right: 5px;
      margin-left: 20px;
      width: 15px;
      height: 15px;
    }
    .link {
      text-decoration: none;
      color: #ffffff;
    }
  }
}
</style>
